import React from 'react'
import { useTranslation } from 'react-i18next'

import { useGetViewerQuery } from '@/generated/graphql'

import { UserManageGroup } from './user-manage-group.component'
import { UserManageUser } from './user-manage-user.component'
import s from './user-manage.module.less'

interface UserManageProps {
  userId: number
}

export const UserManage: React.FC<UserManageProps> = ({ userId }) => {
  const { t } = useTranslation()
  const { data } = useGetViewerQuery()
  const isMe = !!(userId === data?.viewer.userId)

  return (
    <div className={s.container}>
      <div className={s.groups}>
        <UserManageGroup isMe={isMe} type={isMe ? 'myFollowing' : 'userFollowing'} userId={userId} />
        <UserManageGroup isMe={isMe} type={isMe ? 'myCreated' : 'userCreated'} userId={userId} />
      </div>
      <div className={s.users}>
        <UserManageUser
          title={isMe ? t('personalMenu.followUser') : t('personalMenu.theirfollowUser')}
          type='following'
          userId={userId}
        />
        <UserManageUser
          title={isMe ? t('personalMenu.followedUser') : t('personalMenu.theirfollowedUser')}
          type='followed'
          userId={userId}
        />
      </div>
    </div>
  )
}
